import { getToken, getDeviceInfo } from "../Upshow";

/**
 * Build the common request headers.
 *
 * @param {boolean} [isAndroidTV]  – provide it if you already know it,
 *                                   otherwise the helper will detect.
 */
export default function getHeaders(isAndroidTV) {
  if (isAndroidTV === undefined) {
    isAndroidTV =
      window.AndroidTV &&
      typeof window.AndroidTV.isAndroidTV === "function" &&
      window.AndroidTV.isAndroidTV();
  }

  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const device = getDeviceInfo();

  if (isAndroidTV) {
    const { search } = window.location;
    const serial = new URLSearchParams(search).get("serialNumber");
    if (serial) headers["x-serial"] = serial;
  } else if (device.serial) {
    headers["x-serial"] = device.serial;
  }

  const token = getToken();
  if (token) {
    headers["x-access-token"] = token;
    headers.Authorization = `Bearer ${token}`;
  } else {
    console.error("API Token is missing!");
  }

  if (process.env.REACT_APP_APP_VERSION) {
    headers["x-app-version"] = process.env.REACT_APP_APP_VERSION;
  }
  return headers;
}
